import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5802bf48"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "base-step" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "base-step__tail" }, null, -1))
const _hoisted_3 = {
  class: "align-top overflow-hidden",
  style: {"min-height":"80px"}
}
const _hoisted_4 = { class: "font-semibold mb-2" }
const _hoisted_5 = { class: "text-sm leading-6" }

import { Icon } from '@iconify/vue';
interface Props {
  title?: string;
  content?: string;
  loading?: boolean;
  completed?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  props: {
    title: null,
    content: null,
    loading: { type: Boolean },
    completed: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_BaseSpin = _resolveComponent("BaseSpin")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (__props.completed)
      ? (_openBlock(), _createBlock(_unref(Icon), {
          key: 0,
          class: "w-9 h-9 text-success float-left mr-4",
          icon: "bi:check-circle-fill"
        }))
      : (_openBlock(), _createBlock(_component_BaseSpin, {
          key: 1,
          color: "#27AE60",
          inactive: !__props.loading,
          class: "float-left mr-4"
        }, null, 8, ["inactive"])),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, _toDisplayString(__props.title), 1),
      _createElementVNode("div", _hoisted_5, _toDisplayString(__props.content), 1)
    ])
  ]))
}
}

})